// Type guards for JSON (Steam's answers, a stored column), so each value is
// checked before it's used as what it should be.

export const isInteger = (value: unknown): value is number => Number.isInteger(value);

export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

// A number, or null for anything else.
export const numberOrNull = (value: unknown): number | null =>
  typeof value === "number" ? value : null;
